import type { DesignerOptions } from '../designer-types.js';
import type { DesignerLayout } from './shell-types.js';

/**
 * Which chrome a host gets.
 *
 * Two shells, one engine: below 860 px of HOST width the designer is
 * phone-shaped (top bar, Add drawer, property grid) and above it is
 * desktop-shaped (rail, panel card, contextual toolbar). The width is the
 * host's, never the window's — the designer also runs inside the Studio's
 * preview frame and on a harness page whose stage is a resizable box.
 *
 * The coarse-pointer clause is the tablet case: 900 px of width with a finger
 * on it is a phone-shaped problem, not a desktop one, because the reference
 * editor's 22 px handles and hover-only toolbars are unusable that way. Above
 * 1024 px a touch screen is a laptop with a touch screen, and gets the desktop.
 */
export const PHONE_AT = 860;
export const COARSE_DESKTOP_AT = 1024;

export function layoutFor(
  preference: DesignerOptions['layout'],
  width: number,
  coarse: boolean,
): DesignerLayout {
  if (preference === 'desktop' || preference === 'phone') return preference;
  // A width of 0 means "not measured yet"; guessing phone there would build
  // the wrong shell and throw it away one frame later.
  if (width > 0 && width < PHONE_AT) return 'phone';
  if (coarse && width > 0 && width < COARSE_DESKTOP_AT) return 'phone';
  return 'desktop';
}
